import page0 from "./_0_nature_cw-1";
import page1 from "./_1_employer_information";
import page2 from "./_2_point_of_contact_information";
import page3 from "./_3_agent_or_attorney_information";
import page4 from "./_4_occupational_classification";
import page5 from "./_5_minimum_job_requirements";
import page6 from "./_6_place_of_employment_information";
import page7 from "./_7_other_material_terms";
import page8 from "./_8_recruitment_information";
import page9 from "./_9_declaration_of_employer_or_agent_attorney";
import page10 from "./_10_preparer_information";
import page11 from "./_11_appendix_A_employer_client_application";
import page12 from "./_12_appendix_B_additional_worksites";
import page13 from "./_13_application_documents";

const form_meta = {
  code: "Form ETA-9142C",
  name: "CW-1 Application for Temporary Employment Certification",
};

const form_nav = [
  {
    name: "Nature of the CW-1 Application",
    prefix: "A",
  },
  {
    name: "Employer Information",
    prefix: "B",
  },
  {
    name: "Employer Point of Contact Information",
    prefix: "C",
  },
  {
    name: "Attorney or Agent Information (if applicable)",
    prefix: "D",
  },
  {
    name: "Occupational Classification and PWD",
    prefix: "E.a",
  },

  {
    name: "Job Opportunity and Minimum Requirements",
    prefix: "E.b",
  },
  {
    name: "Place of Employment and Wage Information",
    prefix: "E.c",
  },
  {
    name: "Other Material Terms and Conditions of the Job Offer",
    prefix: "E.d",
  },
  {
    name: "Recruitment Information",
    prefix: "E.e",
  },
  {
    name: "Declaration of Employer and Attorney/Agent",
    prefix: "F",
  },
  {
    name: "Preparer",
    prefix: "G",
  },
  {
    name: "Appendix A - Employer Client Application",
    prefix: "APPX <br/>A",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix B - Additional Worksites",
    prefix: "APPX <br/>B",
    classes: "label-prefix-appx",
  },
  {
    name: "Application Documents",
    symbol: "upload",
  },
];

export { form_meta, form_nav };

export default [
  page0,
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  page10,
  page11,
  page12,
  page13,
];
